export function useResetDatagridAvailableColumns() {
  return () => {
    const PREFIX = 'RaStore.preferences.';
    const SUFFIX = '.datagrid.availableColumns';

    const keysToRemove = Object.keys(localStorage).filter(
      (key) => key.startsWith(PREFIX) && key.endsWith(SUFFIX),
    );

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };
}
